import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogProps,
  IconButton,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import React, { ReactNode } from 'react';


export type InformationModalLayoutProps = {
  id: string;
  isVisible: boolean;
  loading?: boolean;
  handleClose: () => void;
  headerIcon?: ReactNode;
  cancelButton?: {
    text: string;
    handleClick: () => void;
  };
  successButton: {
    text: string;
    handleClick: () => void;
  };
  title?: string;
  subTitle?: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InformationModalLayoutProps & Partial<DialogProps>) => {
  const theme = useTheme();
  return (
    <Dialog
      onClick={(e) => e.stopPropagation()}
      fullScreen={props.fullScreen ?? false}
      open={props.isVisible}
      onClose={() => props.handleClose()}
    >
      <Box
        width={!props.fullScreen ? '22rem' : undefined}
        display='flex'
        flexDirection='column'
        rowGap='1.5rem'
      >

        {/* DIALOG HEADER NO TEXT */}
        <Stack
          paddingTop='1.25rem'
          direction='row'
          justifyContent={props.headerIcon ? 'space-between' : 'flex-end'}
          alignItems='start'
        >
          {props.headerIcon
            ? (
              <Box
                display='flex'
                flexDirection='row'
                alignItems='center'
                justifyContent='center'
                borderRadius='.75rem'
                border={`1px solid ${theme.palette.secondary.dark}`}
                width='3rem'
                height='3rem'
              >
                {props.headerIcon}
              </Box>
            )
            : (
              <Box
                display='flex'
                flexDirection='row'
                alignItems='center'
                justifyContent='center'
                borderRadius='.75rem'
                border={`1px solid ${theme.palette.secondary.dark}`}
                width='3rem'
                height='3rem'
              >
                <CustomIcon.large.FC icon='DELETE' />
              </Box>
            )}
          <IconButton
            onClick={() => props.handleClose()}
          >
            <CustomIcon.large.FC
              icon='CLOSE'
            />
          </IconButton>
        </Stack>

        {/* MESSAGE */}
        <Stack>
          {props.title && (
            <Typography
              variant='modalTitle'
            >
              {props.title}
            </Typography>
          )}
          {props.subTitle && (

            <Typography
              variant='modalSubTitle'
            >
              {props.subTitle}
            </Typography>
          )}
        </Stack>

        {/* Action Buttons */}
        <Stack
          direction='row'
          columnGap='.5rem'
          justifyContent='space-between'
        >
          {props.cancelButton && !props.loading && (
            <Button
              variant='outlined'
              onClick={() => props.cancelButton?.handleClick()}
              fullWidth
            >
              {props.cancelButton.text}
            </Button>
          )}
          {!props.loading
          && (
            <Button
              variant='contained'
              color='primary'
              onClick={() => props.successButton.handleClick()}

              fullWidth
            >
              {props.successButton.text}
            </Button>
          )}

          {props.loading && (
            <CircularProgress />
          )}

        </Stack>


      </Box>
    </Dialog>
  );
};
